import { useState, useEffect } from "react";
import { IoAdd } from "react-icons/io5";

import JournalForm from "./JournalForm";
import Modal from "../../../components/common/Modal";
import accountService from "../../../services/accountService";

const JournalHeader = ({ id, refresh, setRefresh }) => {
  const [account, setAccount] = useState(null);

  const [showForm, setShowForm] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    let mounted = true;

    const fetchAccount = async () => {
      const result = await accountService.getAccountInfoAsync(id);
      if (!result) window.location = "/404";
      if (mounted) setAccount(result);
    };

    fetchAccount(id);

    return () => {
      mounted = false;
    };
  }, [id, setAccount]);

  const renderName = () => {
    if (account) {
      const { first_name, middle_name, last_name } = account;
      return `Dr. ${first_name} ${middle_name} ${last_name}`;
    }
  };

  const handleSuccess = () => {
    setShowForm(false);
    setRefresh(!refresh);
  };

  return (
    <>
      <div className="block lg:flex justify-between items-center">
        <div>
          <p className="text-gray-500">Account Journal</p>
          <span className="text-gray-400 text-sm">{renderName()}</span>
        </div>
        <div>
          <button
            className="button button-primary mt-2 md:mt-0"
            onClick={() => setShowForm(true)}
          >
            <IoAdd className="mr-2" />
            Journal Entry
          </button>
        </div>
      </div>
      <Modal
        size="7xl"
        title="Create Journal Entry"
        isOpen={showForm}
        isLoading={isLoading}
        onClose={() => setShowForm(false)}
        borderTop
      >
        <JournalForm
          id={id}
          isLoading={isLoading}
          setLoading={setIsLoading}
          onSuccess={handleSuccess}
        />
      </Modal>
    </>
  );
};

export default JournalHeader;
